import { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useHomePath } from "~/common/useHomePath"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"

export const RequireUserNotOnboardedAndSubscribed = () => {
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()
  const homePath = useHomePath()

  useEffect(() => {
    if (
      !result.loading &&
      currentUser?.isOnboarded &&
      currentUser?.activeSubscription
    ) {
      navigate(homePath)
    }
  }, [currentUser, result.loading, navigate, homePath])

  if (result.loading) {
    return null
  }

  return <Outlet />
}
